/* eslint-disable no-param-reassign */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-nested-ternary */
// prettier-ignore

import fetch  from 'node-fetch';
import moment from 'moment-timezone';

function formatData(data) {
  // console.log(data);

  function makeAddress(item) {
    const elements = [];

    if (item) {
      if (item.street && item.street !== null) {
        elements.push(item.street);
      }

      if (item.city && item.city !== null) {
        elements.push(item.city);
      }

      if (item.state && item.state !== null) {
        elements.push(item.state);
      }

      if (item.zip && item.zip !== null) {
        elements.push(item.zip);
      }
    }

    return elements.join(', ');
  }

  function findAuthorizationNumber(authorizations, key) {
    const item = authorizations.find(
      element => element.authorizationClass === key,
    );

    return item ? item.number : '';
  }

  function updateProducts(products, product, key) {
    const found = products.find(
      item =>
        item.unit === product.unit &&
        item.tirePosition === product.tirePosition &&
        item.productType === product.productType,
    );

    if (!product.hasOwnProperty('confirmed')) {
      product.confirmed = false;
    }

    if (found) {
      found[key] = product;
    } else {
      products.push({
        unit: product.unit,
        tirePosition: product.tirePosition,
        productType: product.productType,
        [key]: product,
      });
    }
  }

  const ersData = {
    eventId: '',
    eventDate: '',
    totalDowntime: '',
    downtimeStart: '',
    downtimeStop: '',
    streetAddress: '',
    city: '',
    state: '',
    address: '',
    fleetName: '',
    fleetShipTo: '',
    fleetContactNumber: '',
    fleetAddress: '',
    vehicleType: '',
    vehicleId: '',
    dealerStoreAddress: '',
    dealerStoreCity: '',
    dealerStoreState: '',
    dealerAddress: '',
    dealerStoreName: '',
    dealerStoreShipTo: '',
    driverName: '',
    contactNumber: '',
    poNumber: '',
    referenceNumber: '',
    invoiceNumber: '',
    ticketNumber: '',
    billingAmount: '',
    billingComments: '',
    tireData: [],
    products: [],
  };

  if (data.data === undefined || data.data.length === 0) {
    return ersData;
  }

  const event = data.data[0];
  const asset = event.assets[0];

  ersData.eventId = event.identifier;
  ersData.eventDate = moment(event.event.attributes.downAt)
    .tz('America/New_York')
    .format('MM-DD-YYYY');

  ersData.vehicleId = asset.unit;
  ersData.vehicleType = asset.assetType;
  ersData.streetAddress = asset.breakdown.street;
  ersData.city = asset.breakdown.city;
  ersData.state = asset.breakdown.state;
  ersData.address = asset ? makeAddress(asset.breakdown) : '';
  ersData.fleetName = event.orderer.name;
  ersData.fleetShipTo = event.orderer.shipTo;
  ersData.fleetAddress = event.orderer.location
    ? makeAddress(event.orderer.location)
    : '';

  ersData.dealerStoreShipTo = event.provider.shipTo
    ? event.provider.shipTo
    : '';
  ersData.dealerStoreName = event.provider.name;
  ersData.dealerStoreAddress =
    event.provider.location && event.provider.location.street
      ? event.provider.location.street
      : '';
  ersData.dealerStoreCity =
    event.provider.location && event.provider.location.city
      ? event.provider.location.city
      : '';
  ersData.dealerStoreState =
    event.provider.location && event.provider.location.state
      ? event.provider.location.state
      : '';
  ersData.dealerAddress = event.provider.location
    ? makeAddress(event.provider.location)
    : '';

  ersData.downtimeStart = event.event.attributes.downAt
    ? moment(event.event.attributes.downAt)
        .tz('America/New_York')
        .format('MM-DD-YYYY hh:mm A Z')
    : '';

  ersData.downtimeStop = event.event.attributes.rollingAt
    ? moment(event.event.attributes.rollingAt)
        .tz('America/New_York')
        .format('MM-DD-YYYY hh:mm A Z')
    : '';

  if (
    event.event.attributes.downAt &&
    event.event.attributes.rollingAt &&
    event.event.attributes.rollingAt !== ''
  ) {
    const startTime = moment(event.event.attributes.downAt);
    const stopTime = moment(event.event.attributes.rollingAt);

    // prettier-ignore
    ersData.totalDowntime = `${moment.duration(stopTime.diff(startTime)).as('minutes')}  mins`;
  }

  ersData.poNumber = findAuthorizationNumber(event.authorizations, 'poNumber');
  ersData.ticketNumber = findAuthorizationNumber(
    event.authorizations,
    'drNumber',
  );
  ersData.referenceNumber = findAuthorizationNumber(
    event.authorizations,
    'referenceNumber',
  );
  ersData.invoiceNumber = findAuthorizationNumber(
    event.authorizations,
    'invoiceNumber',
  );
  ersData.billingAmount = findAuthorizationNumber(
    event.authorizations,
    'billingAmount',
  );
  ersData.billingComments =
    event.invoice && event.invoice.note ? event.invoice.note : '';

  const products = [];
  event.order.products.forEach(item => {
    updateProducts(products, item.attributes, 'order');
  });

  event.estimate.products.forEach(item => {
    updateProducts(products, item.attributes, 'estimate');
  });

  event.invoice.products.forEach(item => {
    updateProducts(products, item.attributes, 'invoice');
  });

  ersData.products = products;

  return ersData;
}

export default async function searchCase(formData) {
  // TODO: this may expose all of our apis to the client in our bundled js -- define and inject from outside of source
  const PROD_API =
    'https://lzvh244xe1.execute-api.us-east-1.amazonaws.com/default/Oncall-Event-Viewer-ElasticSearch-Query';
  const TEST_API =
    'https://oj3ak3brp8.execute-api.us-east-1.amazonaws.com/default/Oncall-Event-Viewer-ElasticSearch-Query';
  const DEV_API =
    'https://oj3ak3brp8.execute-api.us-east-1.amazonaws.com/default/Oncall-Event-Viewer-ElasticSearch-Query';

  const thisUrl = window.location.hostname;

  const esrURL =
    process.env.NODE_ENV === 'production'
      ? thisUrl.toLowerCase().includes('test') ||
        thisUrl.toLowerCase().includes('-dev') ||
        thisUrl.toLowerCase().includes('po-event-viewer.s3-website-us-east-1')
        ? TEST_API
        : PROD_API
      : DEV_API;

  const payload = {
    caseId: '',
    eventDate: '',
    vehicleId: '',
  };

  if (formData.eventNumber) {
    payload.caseId = formData.eventNumber;
  }

  if (formData.eventDate) {
    const momentized = moment(formData.eventDate).format('YYYY-MM-DD');
    payload.eventDate = momentized;
  }

  if (formData.unit) {
    payload.vehicleId = formData.unit;
  }

  const params = {
    method: 'post',
    body: JSON.stringify(payload),
    headers: { 'Content-Type': 'application/json' },
    // mode: 'no-cors',
  };

  let request = await fetch(esrURL, params);

  let jsonResponse = await request.json();

  if (
    jsonResponse.body.data &&
    jsonResponse.body.data.length === 0 &&
    formData.eventDate
  ) {
    // try a different date due to UTC issue
    const momentized = moment(formData.eventDate)
      .add(1, 'd')
      .format('YYYY-MM-DD');
    payload.eventDate = momentized;

    request = await fetch(esrURL, {
      method: 'post',
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'application/json' },
      // mode: 'no-cors',
    });
    jsonResponse = await request.json();
  }

  return formatData(jsonResponse.body);
}
